module.exports = "data:text/x-markdown;base64,TmljZSBvbmUhIFVuaW5pdGlhbGl6ZWQgdmFyaWFibGVzIGluIFNvbGlkaXR5IGFyZSBwYWluIGluIHRoZSBhc3MhDQo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/p2pswapper_complete.md
// module id = 1840
// module chunks = 0